<template>
  <div class="mx--4">
    <el-skeleton
      :rows="10"
      :loading="isLoadingEbooks && ebooks.length == 0"
      animated
    >
      <el-table
        :data="ebooks"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="p-4">
              <Details :ebook="props.row" />
              <el-button-group>
                <!-- <el-button
                  size="mini"
                  type="info"
                  @click="$loading(); getEbookLogs(props.row).then(()=>$loading().close())"
                >
                  Histórico de mudanças
                </el-button> -->
                <el-button
                  v-if="permissions.includes('delete-ebook')"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="onDelete(props.row)"
                >
                  Apagar
                </el-button>
                <a class="el-button el-button--info el-button--mini" :href="props.row.file.url">Baixar</a>
              </el-button-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Id"
          prop="id"
          width="50"
        />
        <el-table-column
          label="Nome"
          prop="name"
        />
        <el-table-column
          fixed="right"
          label="Ações"
          width="220"
        >
          <template slot-scope="{ row }">
            <slot :row="row" />
          </template>
        </el-table-column>
      </el-table>
    </el-skeleton>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import RequestErrors from "@/admin/utils/RequestErrors"
export default {
  name:'EbookListComponent',
  mixins: [RequestErrors],
  computed:{
    ...mapGetters(['permissions','ebooks','isLoadingEbooks']),
  },
  methods:{
    ...mapMutations(['SET_HISTORY', 'SET_EBOOK']),
    ...mapActions(['deleteEbook', 'getEbookLogs']),
    onDelete(ebook){
      this.$confirm('Tem certeza que deseja apagar o página ?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      })
      .then(() => this.deleteEbook(ebook)
      .then(()=>this.$emit('changed')))
      .catch(() => {
        this.$message({
            type: 'info',
            message: 'Ação cancelada!'
        });
      });
    },
  }
}
</script>

